// Mock product & drop data. Swap to Shopify later.

export const coreProducts = [
  {
    id: "question-everything",
    slug: "question-everything",
    name: "Question Everything Hoodie",
    price: 120,
    type: "hoodies",
    badge: "core",
    images: [
      "https://images.unsplash.com/photo-1535395567430-827184ae2eda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxibGFjayUyMHN0cmVldHdlYXIlMjBob29kaWUlMjBtb2NrdXB8ZW58MHx8fHwxNzc2OTg0ODQ4fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1581170678127-390b5aca7999?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxibGFjayUyMHN0cmVldHdlYXIlMjBob29kaWUlMjBtb2NrdXB8ZW58MHx8fHwxNzc2OTg0ODQ4fDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1762343264418-1467f9394f49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzdHJlZXR3ZWFyJTIwZGV0YWlsJTIwdGV4dHVyZSUyMGJsYWNrfGVufDB8fHx8MTc3Njk4NDg0OHww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1605724367507-f12869216950?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxzdHJlZXR3ZWFyJTIwZGV0YWlsJTIwdGV4dHVyZSUyMGJsYWNrfGVufDB8fHx8MTc3Njk4NDg0OHww&ixlib=rb-4.1.0&q=85",
    ],
    sizes: ["S", "M", "L", "XL", "XXL"],
    outOfStockSizes: [],
    status: "available",
    description:
      "Not everything you have been told is true. This piece exists for the ones who never stopped asking why. Built heavy. Built to last. Built for those who think different. 480gsm heavyweight fleece. Garment dyed in black. Designed to outlast the conception.",
    care: "Machine wash cold. Tumble dry low. Do not bleach. Turn inside out before washing.",
  },
  {
    id: "they-got-it-wrong",
    slug: "they-got-it-wrong",
    name: "They Got It Wrong Tee",
    price: 65,
    type: "tees",
    badge: "core",
    images: [
      "https://images.unsplash.com/photo-1633756887168-44c79bddf8b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxibGFjayUyMHRzaGlydCUyMG1vY2t1cCUyMGVkZ3klMjBzdHJlZXR3ZWFyfGVufDB8fHx8MTc3Njk4NDg2NXww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1654076698795-a9f6c4c691f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxibGFjayUyMHRzaGlydCUyMG1vY2t1cCUyMGVkZ3klMjBzdHJlZXR3ZWFyfGVufDB8fHx8MTc3Njk4NDg2NXww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1503341338985-c0477be52513?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxibGFjayUyMHRzaGlydCUyMG1vY2t1cCUyMGVkZ3klMjBzdHJlZXR3ZWFyfGVufDB8fHx8MTc3Njk4NDg2NXww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1507383103958-d65fcc200837?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbW9vZHklMjB1cmJhbiUyMHN0cmVldHdlYXIlMjBmYXNoaW9ufGVufDB8fHx8MTc3Njk4NDg0OHww&ixlib=rb-4.1.0&q=85",
    ],
    sizes: ["S", "M", "L", "XL", "XXL"],
    outOfStockSizes: ["XXL"],
    status: "available",
    description:
      "They got it wrong about you. About where you are from. About what you are capable of. Their conception of you only has power while you live inside it. Step outside it. 240gsm heavyweight cotton. Boxy cut. Oversized fit.",
    care: "Machine wash cold. Tumble dry low. Do not bleach. Turn inside out before washing.",
  },
  {
    id: "not-your-perception",
    slug: "not-your-perception",
    name: "Not Your Perception Jacket",
    price: 240,
    type: "hoodies",
    badge: "core",
    images: [
      "https://images.unsplash.com/photo-1695316944613-6a4bf60f792f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxibGFjayUyMGphY2tldCUyMG1vY2t1cCUyMHN0cmVldHdlYXJ8ZW58MHx8fHwxNzc2OTg0ODY1fDA&ixlib=rb-4.1.0&q=85",
      "https://images.pexels.com/photos/12183148/pexels-photo-12183148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1756276900419-868625adff43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbW9vZHklMjB1cmJhbiUyMHN0cmVldHdlYXIlMjBmYXNoaW9ufGVufDB8fHx8MTc3Njk4NDg0OHww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1589851254324-027baf32f041?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxkYXJrJTIwbW9vZHklMjB1cmJhbiUyMHN0cmVldHdlYXIlMjBmYXNoaW9ufGVufDB8fHx8MTc3Njk4NDg0OHww&ixlib=rb-4.1.0&q=85",
    ],
    sizes: ["S", "M", "L", "XL", "XXL"],
    outOfStockSizes: [],
    status: "available",
    description:
      "The way people see you is not who you are. Someone built a perception before they ever knew you and passed it around like it was fact. This is for the ones who stopped living inside it. Heavy canvas shell. Fully lined. Built for the long walk away.",
    care: "Dry clean only. Do not machine wash.",
  },
  {
    id: "core-shorts",
    slug: "core-shorts",
    name: "Core Black Shorts",
    price: 85,
    type: "shorts",
    badge: "core",
    images: [
      "https://images.pexels.com/photos/10193913/pexels-photo-10193913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1507383103958-d65fcc200837?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbW9vZHklMjB1cmJhbiUyMHN0cmVldHdlYXIlMjBmYXNoaW9ufGVufDB8fHx8MTc3Njk4NDg0OHww&ixlib=rb-4.1.0&q=85",
    ],
    sizes: ["S", "M", "L", "XL", "XXL"],
    outOfStockSizes: [],
    status: "available",
    description: "Core black shorts. Heavy cotton. Boxy. Deep pockets. Built for real days.",
    care: "Machine wash cold. Tumble dry low.",
  },
];

export const drops = [
  {
    id: "wc-system",
    slug: "system-drop",
    category: "Domestic Drop",
    categoryTag: "domestic",
    volume: "Domestic Vol. 1",
    name: "WC x THE SYSTEM",
    location: "United States",
    date: "May 31, 2026",
    status: "coming_soon",
    image:
      "https://customer-assets.emergentagent.com/job_system-drop/artifacts/cbg085dr_Untitled%20Project%20-%20illustrationImage%20%284%29.png",
    description:
      "The system was not designed for your freedom. It was designed for your compliance. For the ones who finally started questioning.",
  },
  {
    id: "wc-guatemala",
    slug: "guatemala-drop",
    category: "International Drop",
    categoryTag: "international",
    volume: "Vol. 1",
    name: "WC x GUATEMALA",
    location: "Guatemala",
    date: "July 2026",
    status: "coming_soon",
    image:
      "https://images.pexels.com/photos/10653712/pexels-photo-10653712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "Their conception of Guatemala was dangerous. Poor. Nothing there. That was the wrong conception. We leave June 18, 2026 to shoot, source, and document. Vol. 1 drops July 2026.",
  },
  {
    id: "wc-origin",
    slug: "origin-drop",
    category: "Domestic Drop",
    categoryTag: "archive",
    volume: "Vol. 0",
    name: "WC ORIGIN",
    location: "Archive",
    date: "2025",
    status: "archived",
    image:
      "https://images.unsplash.com/photo-1761167366043-9e1508c2e474?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxkYXJrJTIwbW9vZHklMjB1cmJhbiUyMHN0cmVldHdlYXIlMjBmYXNoaW9ufGVufDB8fHx8MTc3Njk4NDg0OHww&ixlib=rb-4.1.0&q=85",
    description: "The first conception we challenged. Gone forever.",
  },
];

export const heroImage =
  "https://customer-assets.emergentagent.com/job_system-drop/artifacts/q9wnrpbj_DSC09689.jpg";

export const storySectionImages = {
  questionEverything:
    "https://customer-assets.emergentagent.com/job_system-drop/artifacts/wc8afwjh_DSC09738.jpg",
  theyGotItWrong:
    "https://customer-assets.emergentagent.com/job_system-drop/artifacts/9sw3x1z6_DSC09714.jpg",
  notYourPerception:
    "https://customer-assets.emergentagent.com/job_system-drop/artifacts/ypby59mv_DSC09731.jpg",
};

export const dropTeaserImage =
  "https://customer-assets.emergentagent.com/job_system-drop/artifacts/cbg085dr_Untitled%20Project%20-%20illustrationImage%20%284%29.png";

export const guatemalaHeroImage =
  "https://images.pexels.com/photos/10653712/pexels-photo-10653712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2400";

// Guatemala Drop — cinematic panel imagery (free Unsplash, dark/moody).
// Swap each URL with your own shot when we return from location in June.
export const guatemalaPanels = [
  {
    // Volcán de Fuego erupting at night — iconic Guatemala silhouette
    image:
      "https://images.pexels.com/photos/1659437/pexels-photo-1659437.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2400",
    label: "37 ACTIVE VOLCANOES",
    heading: "THEY THOUGHT IT WAS DANGEROUS.",
    body: "Fuego erupts every few hours. Acatenango lets you sleep beside it. What they called dangerous, we call alive.",
    align: "left",
  },
  {
    // Lake Atitlán — overcast body of water surrounded by hillside (Conor Murphy)
    image:
      "https://images.unsplash.com/photo-1680546718518-89e45a245145?fm=jpg&q=75&w=2400&auto=format&fit=crop",
    label: "LAKE ATITLÁN",
    heading: "HUXLEY CALLED IT THE MOST BEAUTIFUL LAKE IN THE WORLD.",
    body: "Three volcanoes circle it. Twelve villages line it. Every one of them carries a different language and a different conception of time.",
    align: "right",
  },
  {
    // Tikal pyramid rising from dense jungle (Falco Negenman — Tikal, Guatemala)
    image:
      "https://images.unsplash.com/photo-1698869970161-5e90990e1ed3?fm=jpg&q=75&w=2400&auto=format&fit=crop",
    label: "TIKAL — 800 BC",
    heading: "CITIES OLDER THAN ROME. STILL STANDING.",
    body: "The Maya built pyramids taller than the jungle canopy and ran them by astronomy. Then they walked away. Nobody has ever answered why.",
    align: "left",
  },
  {
    // Antigua cobblestone street with volcano backdrop (Daniel — Guatemala)
    image:
      "https://images.unsplash.com/photo-1751752962019-32270d4a5c5d?fm=jpg&q=75&w=2400&auto=format&fit=crop",
    label: "ANTIGUA — CAPITAL OF THE PAST",
    heading: "BUILT IN 1543. BURNED. RECLAIMED. STILL HERE.",
    body: "Three earthquakes couldn't erase it. Three empires tried. The cobblestones are the same ones you walked on five hundred years ago, if you were born in the right place.",
    align: "right",
  },
  {
    // Volcán de Fuego erupting with black smoke — Ben Turnbull, Antigua Guatemala
    image:
      "https://images.unsplash.com/photo-1562920618-92814818f438?fm=jpg&q=75&w=2400&auto=format&fit=crop",
    label: "VOL. 1",
    heading: "WE ARE GOING IN JUNE TO SHOW YOU EVERYTHING THEY GOT WRONG.",
    body: "Shot on location. Built from what we find. No guaranteed restock. If you miss it, you miss it.",
    align: "center",
  },
];

// Target: midnight June 18, 2026 UTC — the moment Vol. 1 drops.
export const guatemalaDropDate = "2026-06-18T00:00:00Z";

export function getProductBySlug(slug) {
  return coreProducts.find((p) => p.slug === slug);
}

export function getDropBySlug(slug) {
  return drops.find((d) => d.slug === slug);
}
